namespace app.support {

    class StfNavigationExtension implements ng.IDirective {

        public link(scope: StfProcessingScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            /**
             * Desabilita a funcionalidade de expandir o menu automaticamente ao passar o mouse.
             */
            scope.$watch(() => {
                let expander = element.parent().find("#ms-navigation-fold-expander");
                if (expander.length > 0) {
                    expander.remove();
                }
            });
        }

        public static factory(): ng.IDirectiveFactory {
            return () => {
                return new StfNavigationExtension();
            };
        }

    }

    angular.module("app.support").directive("stfNavigationExtension", StfNavigationExtension.factory());

    angular.module("app.support").config(($provide: ng.auto.IProvideService) => {
        $provide.decorator("msNavigationItemDirective", ($delegate, $rootScope: ng.IRootScopeService,
                msNavigationService) => {

            /**
             * Lógica para esconder os tooltips quando o menu estiver expandido.
             *
             * Utiliza a classe expanded combinada com navigation-item-tooltip para
             * via CSS esconder o tooltip.
             */
            $rootScope.$watch(() => {
                if (angular.element(".navigation-item-tooltip").length == 0) {
                    return null; // Não processou a diretiva de tooltip ainda.
                }
                return msNavigationService.getFolded(); // Recupera está folded ou não
            }, (newVal, oldVal) => {
                if (!newVal) {
                    angular.element(".navigation-item-tooltip").addClass("expanded");
                } else {
                    angular.element(".navigation-item-tooltip").removeClass("expanded");
                }
            });

            let directive = $delegate[0];

            let originalCompile = directive.compile;


            /**
             * Seta os atributos no elemento anchor de modo a apresentar tooltips.
             */
            directive.compile = (tElement) => {
                let button = tElement.find("a.ms-navigation-button");
                button.attr("fo-tooltip", "");
                button.attr("tooltip-class", "navigation-item-tooltip");
                button.attr("tooltip-position", "right center");
                button.attr("tooltip-template-str", "{{node.title}}");
                button.attr("ui-sref-opts", `{reload: '{{ node.state.split('(')[0] }}'}`);
                return originalCompile(tElement);
            };

            return $delegate;
        });
    });

    class StfNavigationClickExtension implements ng.IDirective {

        public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {

        }

        public static factory(): ng.IDirectiveFactory {
            return () => {
                return new StfNavigationClickExtension();
            };
        }

    }

    angular.module("app.support").directive("stfNavigationClickExtension", StfNavigationClickExtension.factory());

    angular.module("app.support").config(($provide: ng.auto.IProvideService) => {
        $provide.decorator("msNavigationNodeDirective", ($delegate, $rootScope: ng.IRootScopeService,
                msNavigationService, $compile: ng.ICompileService) => {

            /**
             * Lógica expandir o menu quando itens com subitens são clicados
             * e o menu já não está expandido.
             */
            let directive = $delegate[0];
            let originalCompile = directive.compile;

            directive.compile = (tElement) => {
                let postLink = originalCompile(tElement);
                return (scope, element, attrs, ctrl) => {
                    let originalToggleCollapsed = ctrl.toggleCollapsed;
                    ctrl.toggleCollapsed = () => {
                        originalToggleCollapsed();
                        if (msNavigationService.getFolded()) {
                            msNavigationService.toggleFolded();
                            $rootScope.$broadcast("navigationToggledFolded"); // Para forçar a atualização do ícone do toggle.
                        }
                    };
                    return postLink(scope, element, attrs, ctrl);
                };
            };

            return $delegate;
        });
    });
}